












































































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { LotInfo } from '~/models'
import { Schedule } from '~/models/lotInfo'
import { LotTypes } from '~/enums/lots'
import globalStyling from '~/mixins/globalStyling'
import { hasHTMLCode } from '~/utils/htmlDetection'

@Component({})
export default class OtherModelDetailsV3 extends mixins(globalStyling) {
  @Prop({ default: null }) model: Object
  @Prop({ default: null }) lotInfo: LotInfo
  @Prop({ default: null }) lotType: Object

  get schedule(): object {
    return this.lotInfo.schedule.map((schedule: Schedule) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const scheduleCopy = (({ id, saturday, sunday, ...rest }) => rest)(
        schedule
      )

      if (this.haveSameSchedule(scheduleCopy)) {
        return Object.entries({
          'Mon - Fri':
            schedule.monday ||
            schedule.tuesday ||
            schedule.wednesday ||
            schedule.thursday ||
            schedule.friday,
          Saturday: schedule.saturday,
          Sunday: schedule.sunday,
        })
      } else
        return Object.entries({
          Monday: schedule.monday,
          Tuesday: schedule.tuesday,
          Wednesday: schedule.wednesday,
          Thursday: schedule.thursday,
          Friday: schedule.friday,
          Saturday: schedule.saturday,
          Sunday: schedule.sunday,
        })
    })
  }

  get features() {
    return this.lotInfo.features
  }

  get overview() {
    return (
      this.lotInfo.description ||
      this.lotInfo.architectural_submission?.master_plan?.plan?.description ||
      ''
    )
  }

  get cssVariablePrefix(): string {
    return this.lotType === LotTypes.HOME_SITE ? '--ad-sp-hs-' : '--ad-sp-h-'
  }

  haveSameSchedule(obj: any): boolean {
    const valuesArray = Object.values(obj)
    return valuesArray.every((value) => value === valuesArray[0])
  }

  getPropertyName(fieldName: string): string {
    return `${this.cssVariablePrefix}${fieldName.split(' ').join('-')}`
  }

  get additionalDetails() {
    let details: any

    if (this.lotType === LotTypes.HOME_SITE)
      details = {
        'Lot Size': this.lotInfo.size,
        'Lot Number': this.lotInfo.number,
        'Parcel Id': this.lotInfo.parcel_id,
        'Neighborhood': this.lotInfo.neighborhood,
        // Overview: this.lotInfo.description,
      }
    else
      details = {
        Plan: this.lotInfo.architectural_submission?.master_plan?.plan?.name,
        Elevation: this.lotInfo.architectural_submission?.master_plan?.name,
        'Sq Ft': this.lotInfo.architectural_submission?.listing_sqft,
        Architecture:
          this.lotInfo.architectural_submission?.master_plan?.style?.name,
        'Lot Size': this.lotInfo?.size,
        'Neighborhood': this.lotInfo.neighborhood,
        // Overview: this.lotInfo.description,
      }

    return Object.entries(details)
  }

  hasHTMLCode(value: string): boolean {
    return hasHTMLCode(value)
  }

  get shouldShowAdditionalDetails(): boolean {
    return this.additionalDetails.some((detail) =>
      this.isVisible(`${this.getPropertyName(detail[0].toLowerCase())}`)
    )
  }
}
